import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import s from './TooltipsViewer.module.scss';
const TooltipsViewer = () => {
    return _jsx("div", { className: classNames('popover-viewer', s.popoverViewer) });
};
export default TooltipsViewer;
